/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
/**
 * Whether the host page currently refuses nonessential cookies.
 *
 * The switch is a global the host page defines, so it is read on every call rather than captured
 * once: a site flips it as consent changes while the page is open. It is also customer code, so a
 * switch that throws is treated as a refusal - consent could not be established, and assuming it
 * was given is the one outcome that cannot be walked back.
 */
export var areNonessentialCookiesDisabled = function () {
    try {
        var disableCookiesUsage = typeof window !== "undefined" ? window["disableCookiesUsage"] : undefined;
        return typeof disableCookiesUsage === "function" && !!disableCookiesUsage();
    }
    catch (_a) {
        return true;
    }
};
